import type { ButtonHTMLAttributes } from "react";
import css from "./primitives.module.css";

type Variant = "gold" | "secondary" | "destructive";
/** §2.2 lists button type by context, not by an abstract scale. */
type Size = "landing" | "state" | "rail";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
  size?: Size;
};

const VARIANT: Record<Variant, string> = {
  gold: css.gold,
  secondary: css.secondary,
  destructive: css.destructive,
};

const SIZE: Record<Size, string> = {
  landing: css.sizeLanding,
  state: css.sizeState,
  rail: css.sizeRail,
};

export function Button({
  variant = "gold",
  size = "rail",
  className,
  type = "button",
  ...rest
}: ButtonProps) {
  const classes = [css.button, VARIANT[variant], SIZE[size], className ?? ""]
    .filter(Boolean)
    .join(" ");
  return <button type={type} className={classes} {...rest} />;
}
